import styled from "styled-components";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import FormContact from "./comp/FormContact";
import FormMerci from "./comp/FormMerci";

const Section4 = () => {

    const [montrerForm, setMontrerForm] = useState(true);

    return (
        <Wrapper>
            <h2><FontAwesomeIcon icon={faEnvelope} /> <span>Kontakt</span></h2>
            <p>Möchten Sie eine Buchung vornehmen? Sie haben eine Frage zu einer der angebotenen Touren?</p>
            {
                montrerForm && <FormContact setMontrerForm={setMontrerForm} />
            }
            {
                montrerForm === false && <FormMerci />
            }
        </Wrapper>
    )
}

const Wrapper = styled.section``

export default Section4;